/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  MultipleChoiceAnswer,
  MultipleChoiceAnswerCreatePayloadRequest,
  MultipleChoiceAnswerUpdatePayloadRequest,
  ValidationErrorResponse,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MultipleChoiceAnswerFromJSON,
    MultipleChoiceAnswerToJSON,
    MultipleChoiceAnswerCreatePayloadRequestFromJSON,
    MultipleChoiceAnswerCreatePayloadRequestToJSON,
    MultipleChoiceAnswerUpdatePayloadRequestFromJSON,
    MultipleChoiceAnswerUpdatePayloadRequestToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models';

export interface MultipleChoiceAnswersCreateRequest {
    multipleChoiceAnswerCreatePayloadRequest: MultipleChoiceAnswerCreatePayloadRequest;
}

export interface MultipleChoiceAnswersDestroyRequest {
    id: number;
}

export interface MultipleChoiceAnswersListRequest {
    categoryId?: string;
    questionId?: string;
}

export interface MultipleChoiceAnswersUpdateRequest {
    id: number;
    multipleChoiceAnswerUpdatePayloadRequest: MultipleChoiceAnswerUpdatePayloadRequest;
}

/**
 * 
 */
export class MultipleChoiceAnswersApi extends runtime.BaseAPI {

    /**
     */
    async multipleChoiceAnswersCreateRaw(requestParameters: MultipleChoiceAnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MultipleChoiceAnswer>> {
        if (requestParameters.multipleChoiceAnswerCreatePayloadRequest === null || requestParameters.multipleChoiceAnswerCreatePayloadRequest === undefined) {
            throw new runtime.RequiredError('multipleChoiceAnswerCreatePayloadRequest','Required parameter requestParameters.multipleChoiceAnswerCreatePayloadRequest was null or undefined when calling multipleChoiceAnswersCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/multiple_choice_answers/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MultipleChoiceAnswerCreatePayloadRequestToJSON(requestParameters.multipleChoiceAnswerCreatePayloadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MultipleChoiceAnswerFromJSON(jsonValue));
    }

    /**
     */
    async multipleChoiceAnswersCreate(requestParameters: MultipleChoiceAnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MultipleChoiceAnswer> {
        const response = await this.multipleChoiceAnswersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async multipleChoiceAnswersDestroyRaw(requestParameters: MultipleChoiceAnswersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling multipleChoiceAnswersDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/multiple_choice_answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async multipleChoiceAnswersDestroy(requestParameters: MultipleChoiceAnswersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.multipleChoiceAnswersDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async multipleChoiceAnswersListRaw(requestParameters: MultipleChoiceAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MultipleChoiceAnswer>>> {
        const queryParameters: any = {};

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        if (requestParameters.questionId !== undefined) {
            queryParameters['questionId'] = requestParameters.questionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/multiple_choice_answers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MultipleChoiceAnswerFromJSON));
    }

    /**
     */
    async multipleChoiceAnswersList(requestParameters: MultipleChoiceAnswersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MultipleChoiceAnswer>> {
        const response = await this.multipleChoiceAnswersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async multipleChoiceAnswersUpdateRaw(requestParameters: MultipleChoiceAnswersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MultipleChoiceAnswer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling multipleChoiceAnswersUpdate.');
        }

        if (requestParameters.multipleChoiceAnswerUpdatePayloadRequest === null || requestParameters.multipleChoiceAnswerUpdatePayloadRequest === undefined) {
            throw new runtime.RequiredError('multipleChoiceAnswerUpdatePayloadRequest','Required parameter requestParameters.multipleChoiceAnswerUpdatePayloadRequest was null or undefined when calling multipleChoiceAnswersUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/multiple_choice_answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MultipleChoiceAnswerUpdatePayloadRequestToJSON(requestParameters.multipleChoiceAnswerUpdatePayloadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MultipleChoiceAnswerFromJSON(jsonValue));
    }

    /**
     */
    async multipleChoiceAnswersUpdate(requestParameters: MultipleChoiceAnswersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MultipleChoiceAnswer> {
        const response = await this.multipleChoiceAnswersUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
